import { render, staticRenderFns } from "./AssignMenuPermissions.vue?vue&type=template&id=5b31618c&scoped=true"
import script from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
export * from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./AssignMenuPermissions.vue?vue&type=style&index=0&id=5b31618c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31618c",
  null
  
)

export default component.exports